export default [
  {
    title: 'Sobre a Zippi',
    text: `Com a Zippi você pode solicitar seu limite para usar do jeito que quiser, sem preocupações e impulsionar seu capital de giro. Além disso, você pode contratar o empréstimo semanalmente e com o uso do limite do PIX. `,
  },
  {
    title: 'Como funciona o microcrédito?',
    text: `É uma modalidade com foco em microempreendedores que querem montar ou ampliar um negócio. As maiores vantagens são as taxas de juros reduzidas e a facilidade de aprovação.`,
  },
  {
    title: 'Quais são as etapas de contratação?',
    text: `
     Após selecionar a sua oferta em nossa plataforma, você será direcionado para a contratação na plataforma da Zippi:Após selecionar a sua oferta em nossa plataforma, você será direcionado para a contratação na plataforma da Zippi:
      <ol>
        <li>Realize o seu cadastro (CPF, e-mail e telefone)</li>
        <li>Aguarde a análise de crédito e solicite o valor desejado</li>
        <li>Preencha seus dados pessoais para a solicitação da proposta</li>
        <li>Continuar sua solicitação com as informações: RG, CPF e telefone.</li>
        <li>Finalize enviando seu RG ou CNH</li>
      </ol>
    `,
  },
  {
    title: 'Qual a documentação necessária para contratar?',
    text: `É necessário enviar apenas seu RG ou CNH para comprovação.`,
  },
  {
    title: `Qual a taxa de juros da Zippi?`,
    text: `A Zippi cobra uma taxa a partir de 4% na solicitação semanal do empréstimo.`,
  },
  {
    title: `Quais são os requisitos para pedir o empréstimo?`,
    text: `Para solicitar um empréstimo na Zippi, é necessário apenas atuar como MEI ou Autônomo. `,
  },
  {
    title: `Quanto tempo demora para saber se fui aprovado?`,
    text: `Você saberá se foi aprovado ou não em poucos dias após a sua solicitação do empréstimo.`,
  },
  {
    title: `Em quanto tempo vou receber o dinheiro na minha conta bancária?`,
    text: `Você receberá o dinheiro na sua conta de forma imediata via Pix.`,
  },
]
